export type TReversegeoProperty = {
	address: string;
	city: string;
	country: string;
	postal: string;
	state: string;
	street: string;
	street_number: string;
	epoch: number;
} | undefined;

export const convertToReversegeoProperty = (data: {[key: string]: string}, epoch?: string): TReversegeoProperty => {
	if (!data["REPORT:reversegeo:address:clock"] && !epoch) {
		return undefined;
	}

	return {
		address: data["REPORT:reversegeo:address"],
		city: data["REPORT:reversegeo:city"],
		country: data["REPORT:reversegeo:country"],
		postal: data["REPORT:reversegeo:postal"],
		state: data["REPORT:reversegeo:state"],
		street: data["REPORT:reversegeo:street"],
		street_number: data["REPORT:reversegeo:street_number"],
		epoch: Number.parseInt(epoch || data["REPORT:reversegeo:address:clock"], 10),
	};
};
